import React from 'react'
import { Modal } from 'react-bootstrap'

import { useComponentVisible, User, Cart } from '@monorepo/hooks'
import { OfferType } from '@monorepo/interfaces'
import { OrderForm } from './OrderForm'

type AddToCartButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  item: OfferType
}

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  item,
  children,
  ...props
}) => {
  const {
    isComponentVisible,
    showComponentHandler,
    hideComponentHandler,
  } = useComponentVisible(false)
  const { checkPermissions } = User.useAcl()
  const { addCartItemHandler } = Cart.useCart()

  return (
    <>
      <button
        type="button"
        aria-label="Добавить в корзину"
        {...props}
        onClick={async () =>
          (await checkPermissions({ guest: false })) && showComponentHandler()
        }
      >
        {children}
      </button>

      <Modal show={isComponentVisible} onHide={hideComponentHandler}>
        <Modal.Header closeButton>
          <Modal.Title>{item.good.name}</Modal.Title>
        </Modal.Header>
        <OrderForm
          item={item}
          addHandler={addCartItemHandler.bind(null, item)}
          onClose={hideComponentHandler}
        />
      </Modal>
    </>
  )
}
